import type { StatsResponseCore } from "../utils/statsViewModel";
import { StatsCard } from "./StatCard";

/**
 * The membership stat block shared by the two detail views: the large gender
 * card plus the two summary cards (Zugänge/Stornos and Abgänge/Kündigungen).
 * Reads straight from the {@link StatsResponseCore}; carries no logic — the
 * numbers are already shaped by the API.
 */
export function MembershipStatsCards({
  core,
  title,
  activationsTooltip,
  cancellationsTooltip,
}: {
  core: StatsResponseCore | undefined;
  title: string | undefined;
  activationsTooltip: string;
  cancellationsTooltip: string;
}) {
  return (
    <div className="flex flex-col gap-1">
      <StatsCard.Large
        title={title}
        value={core?.total.active}
        compareValue={core?.change.total}
        genderData={[
          { label: "Männer", value: core?.demographics.male.count },
          { label: "Frauen", value: core?.demographics.female.count },
          { label: "Divers", value: core?.demographics.diverse.count },
        ]}
      />

      <StatsCard.Double
        highlight
        highlightColor="bg-primary-400 !text-white"
        tooltip={activationsTooltip}
        items={[
          {
            title: "Zugänge",
            sign: "",
            value: core?.total.activations,
            className: "text-white",
          },
          {
            title: "Stornos",
            sign: "",
            value: core?.total.stornos,
            className: "!text-white",
          },
        ]}
      />

      <StatsCard.Double
        highlight
        tooltip={cancellationsTooltip}
        items={[
          {
            title: "Abgänge",
            sign: "",
            value: core?.total.cancellations,
            className: "text-gray-600",
          },
          {
            title: "davon in Testphase",
            className: "!text-gray-500",
            sign: "",
            value: core?.total.terminationsInTestPhase,
          },
          {
            title: "Kündigungen",
            sign: "",
            value: core?.total.terminations,
          },
        ]}
      />
    </div>
  );
}
